


<!-- <div mdbModal #slideShowModal="mdbModal" class="modal fade" tabindex="-1" role="dialog"
  aria-labelledby="myBasicModalLabel" aria-hidden="true"
  [config]="{backdrop: true, ignoreBackdropClick: true,  keyboard: false}">
  <div class="modal-dialog modal-md modal-dialog-centered" role="document" *ngIf="imageData">

    <div class="modal-content">
      <button type="button" class="close" data-dismiss="modal" aria-label="Close"
      (click)="closeImgPreview()">
      <span aria-hidden="true" class="">&times;</span>
    </button>
      <hr>
      <div class="col-md-12 imagePreview-tab">
        <img src="../../../../assets/img/home/leftarrow_ic.svg" alt="" class="slickPrev profile-left-image">
        <img src="../../../../assets/img/home/rightarrow_ic.svg" alt="" class="slickNext profile-right-image">
        <div class="preview-slider">
          <div class="preview">
            <div class="slider-image">
              <ngx-slick-carousel class="row " #slickModal="slick-carousel" [config]="slideConfig">
                <div ngxSlickItem *ngFor="let profile of imageData" class="imgContainer">
                  <img [src]="profile?.fullPhotoPath" alt="" class="profileImg">
                </div>
              </ngx-slick-carousel>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div> -->

<div class="news-modal image-modal" id="modal-content-wrapper">
  <header id="modal-header">
    <h4 id="modal-title">Photo Album</h4>
    <button
      type="button"
      class="close pull-right"
      aria-label="Close"
      (click)="closeModal()"
    >
      <span aria-hidden="true">×</span>
    </button>
  </header>
  <section id="modal-body">
    <div class="col-md-12 imagePreview-tab">
      <img *ngIf="imageData.length > 0" src="../../../../assets/img/home/leftarrow_ic.svg" alt="" class="slickPrev profile-left">
      <img *ngIf="imageData.length > 0" src="../../../../assets/img/home/rightarrow_ic.svg" alt="" class="slickNext profile-right">
      <div class="preview-slider">
        <div class="preview">
          <div>
            <ngx-slick-carousel class="row slick" #slickModal="slick-carousel" [config]="slideConfig">
              <div ngxSlickItem *ngFor="let profile of imageData">
                <div class="imgContainer">
                  <img [src]="profile?.fullPhotoPath" alt="" class="profileImg">
                </div>
              </div>
            </ngx-slick-carousel>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>